import Phaser from 'phaser';
export default class AParticle extends Phaser.GameObjects.Particles.Particle
{
    constructor (emitter)
    {
        super(emitter);

        this.t = 0;
        this.i = 0;

        this.scene = this.emitter.manager.scene;
        this.anim = this.scene.anims.anims.entries[this.emitter.anim];
    }

    update (delta, step, processors)
    {
        let result = super.update(delta, step, processors);
        if(this.anim != null)
        {
            this.t += delta;

            if (this.t >= this.anim.msPerFrame) {
                this.i++;

                if (this.i >= this.anim.frames.length) {
                    this.i = 0;
                }

                this.frame = this.anim.frames[this.i].frame;

                this.t -= this.anim.msPerFrame;
            }
        }
        return result;
    }
}